const alphabet = "abcdefghijklmnopqrstuvwxyz";

export const getLetterFromAlphabet = (index: number, uppercase?: boolean): string => {
    const letter = alphabet[index] || "";
    return uppercase ? letter.toUpperCase() : letter;
};
